import {reactive} from "vue";
import ApontamentoEntidadeEvent from "@/domain/events/apontamentoEntidade.event";

class PlanoSeguroEvents {

    apontamentoEvent = new ApontamentoEntidadeEvent()

    listenerPlanoSeguroGravado = reactive({value: {planoSeguroId: ''}})
    listenerPlanoSeguroAlterado = reactive({value: {planoSeguroId: ''}})

    emitPlanoSeguroGravado(planoSeguroId: string) {
        this.listenerPlanoSeguroGravado.value = {planoSeguroId: planoSeguroId}
    }

    emitPlanoSeguroAlterado(planoSeguroId: string) {
        this.listenerPlanoSeguroAlterado.value = {planoSeguroId: planoSeguroId}
    }


}

export default PlanoSeguroEvents;